<template>
	<div>
		<div class="data39">
			<div class="data39Til">{{list.data.menuTitle}}</div>
			<div class="data39Cen">{{list.data.desc}}</div>
			<div class="data39Img" :style="{
				width:`calc(100% - ${bj}px)`
			}">
				<img :src="list.data.cover" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				bj: ''
			}
		},
		mounted() {
			this.getWidth();
		},
		methods: {
			getWidth() {
				console.log(document.body.clientWidth, window.screen.availWidth)
				let width = ''
				if (document.body.clientWidth > 1200) {
					width = document.body.clientWidth - 1200;
				} else {
					width = 0;
				}
				this.$nextTick(function() {
					this.bj = width / 2
				})
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data39 {
		padding-bottom: 150px;

		.data39Til {
			font-size: 45px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			width: 1200px;
			margin: 0 auto 35px;
		}

		.data39Cen {
			font-size: 26px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #000000;
			width: 1200px;
			margin: 0 auto 40px;
			white-space: pre-line;
		}

		.data39Img {
			width: 80%;
			height: 600px;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
	}

	@media screen and (max-width:1200px) {
		.data39 {
			width: 100% !important;
			margin-bottom: 0px !important;
			padding: 0 30px 30px !important;
			box-sizing: border-box;
			.data39Til{
				font-size: 24px !important;
				width: 100% !important;
				margin: 0 auto 20px !important;
			}
			.data39Cen {
				font-size: 14px !important;
				width: 100% !important;
				margin: 0 auto 20px !important;
			}
			
			.data39Img {
				width: 100% !important;
				height: auto !important;
			
				img {
					width: 100%;
					height: auto !important;
					object-fit: contain !important;
				}
			}
		}
	}
</style>